import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav
      aria-label="面包屑导航"
      className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500 md:text-sm"
    >
      <i className="ri-home-4-line text-sm" />
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.path && !isLast ? (
              <Link
                to={item.path}
                className="transition-colors hover:text-accent-600"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "font-medium text-foreground-800" : ""}>
                {item.label}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" />}
          </span>
        );
      })}
    </nav>
  );
}